"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconSafety = function IconSafety(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M22.5 5.784a38 38 0 0 1-6.24 2.926 32 32 0 0 1-6.413 1.692c-.911.13-1.65.831-1.828 1.746L8 12.317c-.207 8.897 1.78 16.347 5.899 22.25l.29.409a24.84 24.84 0 0 0 8.324 7.557c.606.35 1.368.35 1.987-.007l.916-.55c4.143-2.515 6.517-4.402 8.395-7 4.208-5.818 6.296-13.211 6.2-22.04L40 12.33l-.014-.16a2.14 2.14 0 0 0-1.877-1.784 30 30 0 0 1-6.198-1.668 48 48 0 0 1-7.466-2.963c-.565-.328-1.327-.328-1.946.029m.304 2.13.696-.398a49.5 49.5 0 0 0 7.76 3.09 31.5 31.5 0 0 0 5.905 1.649l.739.125q.075.023.098.078L38 12.34c.194 8.71-1.775 15.885-5.81 21.464-1.685 2.331-3.897 4.087-7.83 6.474l-.86.516a22.9 22.9 0 0 1-7.374-6.545l-.59-.83C11.768 28.004 9.895 21.185 9.99 12.98l.008-.496.024-.038a.2.2 0 0 1 .12-.067 34 34 0 0 0 6.813-1.795 40 40 0 0 0 5.85-2.672m6.578 5.926c1.415.518 2.882.881 4.376 1.085.572.078.999.565 1.002 1.132a34 34 0 0 1-.178 4.457l-.086.74-.992-.128q.322-2.51.256-5.053a.16.16 0 0 0-.137-.158 22 22 0 0 1-4.026-.94l-.559-.195zM16.456 27.704a19 19 0 0 0 1.88 3.254 17.6 17.6 0 0 0 2.817 3.069l.401.334-.628.778a18.6 18.6 0 0 1-3.402-3.597 20 20 0 0 1-1.74-2.913l-.24-.513z",
    clipRule: "evenodd"
  })));
};

export { IconSafety, IconSafety as default };
